import type { ICRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';
import {
  ClickEventComponentNames,
  CustomEventNames,
  EventTypes,
} from '@fhs-legacy/frontend/src/state/crm-events/constants';

export const logCartContinue = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue in Cart',
      cart_version: 'fresh',
    },
  });
};

export const logCartPlaceOrder = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Place Secure Order',
      cart_version: 'fresh',
    },
  });
};

export const logCartContinueOrder = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Other,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Continue',
      cart_version: 'fresh',
    },
  });
};

export const logPaymentMethodSelected = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  paymentMethodType: string
) => {
  logRBIEvent({
    name: CustomEventNames.SAVE_NEW_PAYMENT_METHOD,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: `Select Payment Method: ${paymentMethodType}`,
      cart_version: 'fresh',
    },
  });
};

export const logPaymentMethodSelectionOpened = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Open Payment Method Selection',
      cart_version: 'fresh',
    },
  });
};

export const logAddNewPaymentCard = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Add New Payment Card',
      cart_version: 'fresh',
    },
  });
};

export const logPaymentRetry = (logRBIEvent: ICRMEventsContext['logRBIEvent'], message) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: `Retrying payment ${message}`,
      cart_version: 'fresh',
    },
  });
};

export const logServiceModeSelected = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  serviceMode: string
) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: `Select Service Mode: ${serviceMode}`,
      cart_version: 'fresh',
    },
  });
};

export const logTimeSelectionConfirmed = (
  logRBIEvent: ICRMEventsContext['logRBIEvent'],
  selectedTime: string
) => {
  logRBIEvent({
    name: CustomEventNames.CLICK_EVENT,
    type: EventTypes.Transaction,
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      text: 'Confirm Time Selection',
      selectedTime,
      cart_version: 'fresh',
    },
  });
};

export const logCheckoutDiscountNotApplied = (logRBIEvent: ICRMEventsContext['logRBIEvent']) => {
  logRBIEvent({
    name: CustomEventNames.DISCOUNT_NOT_APPLIED,
    type: EventTypes.Other,
    attributes: {
      text: 'User has incentive but not applied to the cart',
      cart_version: 'fresh',
    },
  });
};
